//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    name: 'paymentRule',
    methods: {
        enterTo() {
            window.location.href = `cmcchkhsh://ticketList`
        }
    }
}



// WEBPACK FOOTER //
// ./src/page/paymentRule/index2.vue